var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('div',{staticClass:"text-center"},[_c('v-img',{attrs:{"width":"80%","src":require("@/assets/not_found.svg"),"alt":"404"}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }